// core version + navigation, pagination modules:
import SwiperCore, {Navigation, Pagination, Autoplay} from 'swiper';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

const Swipers = {}


Swipers.imageSlider = new SwiperCore('.image-slider ', {
    autoplay: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
        nextEl: ".arrow--next",
        prevEl: ".arrow--prev",
    },
    breakpoints: {
        // when window width is >= 767px
        767: {
            slidesPerView: 2
        },
        1024: {
            slidesPerView: 3
        }
    }
});

Swipers.imageSlider = new SwiperCore('.full-image-slider ', {
    autoplay: true,
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
        nextEl: ".arrow--next",
        prevEl: ".arrow--prev",
    },
});

Swipers.reviewSlider = new SwiperCore('.review-slider ', {
    slidesPerView: 1,
    loop: false,
    grabCursor: true,
    a11y: true,
    spaceBetween: 83,
    watchOverflow: true,
    navigation: {
        nextEl: ".arrow--next",
        prevEl: ".arrow--prev",
    },
    breakpoints: {
        767: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 3
        }
    }
});


Swipers.imageSlider = new SwiperCore('.related-post-slider ', {
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
        767: {
            slidesPerView: 2
        },
        1024: {
            slidesPerView: 3
        }
    }
});
